var PageSvcsAdd = (function ($) {

    PageSvcsAdd = function (options) {
        var that = this;

        that.class = {
            svcs_add_total_drawer_call: 'js-add-total-call',
            svcs_add_total_content: 'js-svcs-add-total-content',
            svcs_add_total_segment: 'js-side-total-segment',
            svcs_add_total_item: 'js-side-total-item',
            svcs_add_total_item_count: 'js-side-total-item-count',
            svcs_add_total_item_amount: 'js-side-total-item-amount',
            svcs_add_total_amount: 'js-side-total-amount',

            svc_card_wrapper: 'js-svc-card-wrapper',
            svc_type_card: 'js-svc-type-card',

            svc_badge_added: 'js-svc-badge-added',
            svc_badge_added_quantity: 'js-svc-badge-added-quantity',

            svc_badge_paid: 'js-svc-badge-paid',
            svc_badge_paid_quantity: 'js-svc-badge-paid-quantity',

            // non-obvious use in __initSvcsDetailsModal()
            svcs_seat_assignment_details_modal_call: 'js-seat_assignment-details-modal-call',
            svcs_luggage_details_modal_call: 'js-luggage-details-modal-call',
            svcs_insurance_details_modal_call: 'js-insurance-details-modal-call',
            svcs_notice_details_modal_call: 'js-notice-details-modal-call',
            svcs_ife_movies_details_modal_call: 'js-ife_movies-details-modal-call',
            svcs_meal_details_modal_call: 'js-meal-details-modal-call',

            svcs_ife_movies_drawer_call: 'js-ife_movies-drawer-call',
            svcs_ife_movies_html: 'js-drawer-ife-movies-html',

            svcs_meal_drawer_call: 'js-meal-drawer-call',
            svcs_meal_html: 'js-drawer-meal-html',

            svcs_insurance_drawer_call: 'js-insurance-drawer-call',
            svcs_insurance_html: 'js-drawer-insurance-html',

            svcs_notice_drawer_call: 'js-notice-drawer-call',
            svcs_notice_html: 'js-drawer-notice-html',

            svcs_seat_drawer_call: 'js-seat_assignment-drawer-call',
            svcs_seat_html: 'js-drawer-seats-html',

            svcs_luggage_drawer_call: 'js-luggage-drawer-call',
            svcs_luggage_html: 'js-drawer-luggage-html',

            svc_action: 'js-svc-action',
            svc_action_add: 'js-svc-action-add',
            svc_action_edit: 'js-svc-action-edit',

            svc_action_submit: 'js-svc-action-submit',
            svc_action_submit_text_desktop: 'js-svc-action-submit-text-desktop',
            svc_action_submit_text_mobile: 'js-svc-action-submit-text-mobile',
            svc_action_confirm: 'js-svc-action-confirm',
            svc_action_cancel: 'js-svc-action-cancel'
        };

        that.$wrapper = options['$wrapper'];

        if (that.$wrapper && that.$wrapper.length) {
            // DOM
            that.segments_passengers = options['segments_passengers'] || [];
            that.passengers = options['passengers'] || [];
            that.modals = options['modals'];
            that.locales = options['locales'];
            that.order_currency = options['order_currency'] || '';
            that.order_segments_ids = options.order_segments_ids;
            that.order_passengers_ids = options.order_passengers_ids;

            that.seats_incomplete_warning_enable = options['seats_incomplete_warning_enable'];
            that.seats_incomplete_warning_html = that.modals['seats_incomplete_warning_html'];

            that.luggage_incomplete_warning_enable = options['luggage_incomplete_warning_enable'];
            that.luggage_incomplete_warning_html = that.modals['luggage_incomplete_warning_html'];

            that.ife_movies_need_force_select = true;

            that.meal_incomplete_warning_enable = options['meal_incomplete_warning_enable'];
            that.meal_incomplete_warning_html = that.modals['meal_incomplete_warning_html'];

            // CONST
            that.SVC_TYPES = {
                seat: 'seat_assignment',
                luggage: 'luggage',
                ife_movies: 'ife_movies',
                meal: 'meal',
                insurance: 'insurance',
                notice: 'notice'
            };

            // DYNAMIC VARS
            that.seats_items_unpaid = options['seats_items_unpaid'] || [];
            that.seats_items_paid = options['seats_items_paid'] || [];
            that.seats_items_default = options['seats_items_default'] || [];

            that.luggage_items_unpaid = options['luggage_items_unpaid'] || [];
            that.luggage_items_paid = options['luggage_items_paid'] || [];
            that.luggage_items_default = options['luggage_items_default'] || [];

            that.ife_movies_items_unpaid = options['ife_movies_items_unpaid'] || [];
            that.ife_movies_items_paid = options['ife_movies_items_paid'] || [];
            that.ife_movies_items_default = options['ife_movies_items_default'] || [];

            that.meal_items_unpaid = options['meal_items_unpaid'] || [];
            that.meal_items_paid = options['meal_items_paid'] || [];
            that.meal_items_default = options['meal_items_default'] || [];

            that.insurance_items_unpaid = options['insurance_items_unpaid'] || [];
            that.insurance_items_paid = options['insurance_items_paid'] || [];
            that.insurance_items_default = options['insurance_items_default'] || [];

            that.notice_items_unpaid = options['notice_items_unpaid'] || [];
            that.notice_items_paid = options['notice_items_paid'] || [];
            that.notice_items_default = options['notice_items_default'] || [];

            that.total = options['total'] || 0;

            // HANDLERS
            that.onSvcSelected = (options['onSvcSelected'] || function () {});
            that.onSvcReset = (options['onSvcReset'] || function () {});

            //ANALYTICS
            /** @type {AnalyticsSvcsDataset} */
            that.analytics_dataset = options.analytics_dataset || null;

            // INIT
            that.init();
        }
    }

    PageSvcsAdd.prototype.init = function () {
        var that = this;

        //
        that.svcAddTotalDrawerInit();
        //
        that.initSvcsSeatDetailsModal();
        //
        that.initSvcsLuggageDetailsModal();
        //
        that.initSvcsIfeMoviesDetailsModal();
        //
        that.initSvcsMealDetailsModal();
        //
        that.initSvcsInsuranceDetailsModal();
        //
        that.initSvcsNoticeDetailsModal();
        //
        that.svcSeatDrawerHandler();
        //
        that.svcLuggageDrawerHandler();
        //
        that.svcIfeMoviesDrawerHandler();
        //
        that.svcMealDrawerHandler();
        //
        that.svcInsuranceDrawerHandler();
        //
        that.svcNoticeDrawerHandler();
        //
        that.__svcBadgeToggle('added', false);
        //
        that.__svcBadgeToggle('paid', false);
        //
        // set action button state empty
        that.__svcSetActionStateAdd();
        //
        // this event should be before add_to_cart events
        $.sa.analytics.gtagSelectContent('page', 'svc_add_list');
        //
        that.__showInitialSvcsPaid();
        //
        // if there are initially selected unpaid items
        if (
            that.seats_items_unpaid.length ||
            that.luggage_items_unpaid.length ||
            that.meal_items_unpaid.length ||
            that.insurance_items_unpaid.length ||
            that.notice_items_unpaid.length
        ) {
            that.__showInitialSvcsUnpaid();
        }
            // if there is no initially selected unpaid items -
        // just display default svcs total
        else {
            that.__displayTotal();
        }

        // if there are initially default items
        if (
            that.seats_items_default.length ||
            that.luggage_items_default.length ||
            that.meal_items_default.length ||
            that.insurance_items_default.length ||
            that.notice_items_default.length
        ) {
            that.__showInitialSvcsDefault();
        }

            // if there is no initially default items -
        // just display default svcs total
        else {
            that.__displayTotal();
        }
    };

    PageSvcsAdd.prototype.__showInitialSvcsUnpaid = function () {
        var that = this;

        var showSvcs = function (svcs_collection, svc_type) {
            // perform functions called after selection and collection changes
            // (don't need to call __saveSvcInCollection() - these items are already in collection)
            that.__afterCollectionChanged(svcs_collection, svc_type);

            svcs_collection.forEach(function (svc) {
                var svc_quantity = svc.item_quantity ? parseInt(svc.item_quantity, 10) : 0;
                // add item_quantity_diff into svc data - equals svc quantity
                that.__afterSvcSelect(Object.assign({}, svc, {item_quantity_diff: svc_quantity}));
            });
        };

        if (that.seats_items_unpaid.length) {
            showSvcs(that.seats_items_unpaid, that.SVC_TYPES.seat);
        }

        if (that.luggage_items_unpaid.length) {
            showSvcs(that.luggage_items_unpaid, that.SVC_TYPES.luggage);
        }

        if (that.ife_movies_items_unpaid.length) {
            showSvcs(that.ife_movies_items_unpaid, that.SVC_TYPES.ife_movies);
        }

        if (that.meal_items_unpaid.length) {
            showSvcs(that.meal_items_unpaid, that.SVC_TYPES.meal);
        }

        if (that.insurance_items_unpaid.length) {
            showSvcs(that.insurance_items_unpaid, that.SVC_TYPES.insurance);
        }

        if (that.notice_items_unpaid.length) {
            showSvcs(that.notice_items_unpaid, that.SVC_TYPES.notice);
        }
    };

    PageSvcsAdd.prototype.__showInitialSvcsPaid = function () {
        var that = this;

        if (that.seats_items_paid.length) {
            // show badge "Paid"
            that.__svcBadgePaidSet(that.SVC_TYPES.seat, that.seats_items_paid);
        }

        if (that.luggage_items_paid.length) {
            that.__svcBadgePaidSet(that.SVC_TYPES.luggage, that.luggage_items_paid);
        }

        if (that.ife_movies_items_paid.length) {
            that.__svcBadgePaidSet(that.SVC_TYPES.ife_movies, that.ife_movies_items_paid);
        }

        if (that.meal_items_paid.length) {
            that.__svcBadgePaidSet(that.SVC_TYPES.meal, that.meal_items_paid);
        }

        if (that.insurance_items_paid.length) {
            that.__svcBadgePaidSet(that.SVC_TYPES.insurance, that.insurance_items_paid);
        }

        if (that.notice_items_paid.length) {
            that.__svcBadgePaidSet(that.SVC_TYPES.notice, that.notice_items_paid);
        }
    };

    PageSvcsAdd.prototype.__showInitialSvcsDefault = function () {
        var that = this;

        var showSvcs = function (svcs_collection, svc_type) {
            // perform functions called after selection and collection changes
            // (don't need to call __saveSvcInCollection() - these items are already in collection)
            that.__afterCollectionChanged(svcs_collection, svc_type);

            // add item_quantity_diff into svc data - equals svc quantity
            svcs_collection = svcs_collection.map(svc => Object.assign({}, svc, {item_quantity_diff: svc.item_quantity ? parseInt(svc.item_quantity, 10) : 0}));

            svcs_collection.forEach(function (svc) {
                var svc_quantity = svc.item_quantity ? parseInt(svc.item_quantity, 10) : 0;
                // add item_quantity_diff into svc data - equals svc quantity
                that.__afterSvcSelect(Object.assign({}, svc, {item_quantity_diff: svc_quantity}));
            });

            if (that.analytics_dataset) {
                var event_data = that.analytics_dataset.svcCartChange(svcs_collection);
                if (event_data.add_to_cart) {
                    $.sa.analytics.gtag('event', 'add_to_cart', event_data.add_to_cart);
                }
            }
        };

        if (that.seats_items_default.length) {
            showSvcs(that.seats_items_default, that.SVC_TYPES.seat);
        }

        if (that.luggage_items_default.length) {
            showSvcs(that.luggage_items_default, that.SVC_TYPES.luggage);
        }

        if (that.ife_movies_items_default.length) {
            showSvcs(that.ife_movies_items_default, that.SVC_TYPES.ife_movies);
        }

        if (that.meal_items_default.length) {
            showSvcs(that.meal_items_default, that.SVC_TYPES.meal);
        }

        if (that.insurance_items_default.length) {
            showSvcs(that.insurance_items_default, that.SVC_TYPES.insurance);
        }

        if (that.notice_items_default.length) {
            showSvcs(that.notice_items_default, that.SVC_TYPES.notice);
        }
    };

    /**
     * Reset all unpaid svcs of specified type
     * @param {String} svc_type
     */
    PageSvcsAdd.prototype.resetSvcsUnpaid = function (svc_type) {
        var that = this;

        var resetSvcs = function (svcs_collection, svcs_type) {
            var svcs = svcs_collection.filter(function (svc) {
                    if (!svc.hasOwnProperty('item_quantity')) {
                        return false;
                    }
                    return parseInt(svc.item_quantity, 10) !== 0;
                });

            if (!svcs.length) {
                return;
            }

            svcs.forEach(function (svc) {
                that.__resetSvcInCollection(svcs_collection, svc);
            });
            that.__afterCollectionChanged(svcs_collection, svcs_type);
        };

        if (svc_type === that.SVC_TYPES.seat) {
            resetSvcs(that.seats_items_unpaid, that.SVC_TYPES.seat);
        }
        else if (svc_type === that.SVC_TYPES.luggage) {
            resetSvcs(that.luggage_items_unpaid, that.SVC_TYPES.luggage);
        }
        else if (svc_type === that.SVC_TYPES.ife_movies) {
            resetSvcs(that.ife_movies_items_unpaid, that.SVC_TYPES.ife_movies);
        }
        else if (svc_type === that.SVC_TYPES.meal) {
            resetSvcs(that.meal_items_unpaid, that.SVC_TYPES.meal);
        }
        else if (svc_type === that.SVC_TYPES.insurance) {
            resetSvcs(that.insurance_items_unpaid, that.SVC_TYPES.insurance);
        }
        else if (svc_type === that.SVC_TYPES.notice) {
            resetSvcs(that.notice_items_unpaid, that.SVC_TYPES.notice);
        }
        else {
            $.sa.error(`PageSvcsAdd.resetSvcsNotPaid: undefined svc type ${svc_type}`);
        }
    };

    PageSvcsAdd.prototype.initSvcsSeatDetailsModal = function () {
        var that = this;
        that.__initSvcsDetailsModal(that.SVC_TYPES.seat);
    };

    PageSvcsAdd.prototype.initSvcsLuggageDetailsModal = function () {
        var that = this;
        that.__initSvcsDetailsModal(that.SVC_TYPES.luggage);
    };

    PageSvcsAdd.prototype.initSvcsIfeMoviesDetailsModal = function () {
        var that = this;
        that.__initSvcsDetailsModal(that.SVC_TYPES.ife_movies);
    };

    PageSvcsAdd.prototype.initSvcsMealDetailsModal = function () {
        var that = this;
        that.__initSvcsDetailsModal(that.SVC_TYPES.meal);
    };

    PageSvcsAdd.prototype.initSvcsInsuranceDetailsModal = function () {
        var that = this;
        that.__initSvcsDetailsModal(that.SVC_TYPES.insurance);
    };

    PageSvcsAdd.prototype.initSvcsNoticeDetailsModal = function () {
        var that = this;
        that.__initSvcsDetailsModal(that.SVC_TYPES.notice);
    };

    PageSvcsAdd.prototype.__initSvcsDetailsModal = function (type) {
        var that = this;

        that.$wrapper.on('click', '.' + that.class['svcs_' + type + '_details_modal_call'], function (e) {
            e.preventDefault();

            $.uiModal({
                html: that.modals['details'][type]
            });
        });
    };

    PageSvcsAdd.prototype.svcSeatDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_seat_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_seat_html}`).html();

            // Merge unpaid and default items (without overriding)
            var seats_items_unpaid = that.__mergeIntoCollection(that.seats_items_unpaid, that.seats_items_default);
            // Save into unpaid
            that.seats_items_unpaid = seats_items_unpaid.slice();
            // deep clone with all embedded objects
            var seats_items_unpaid_initial = JSON.parse(JSON.stringify(seats_items_unpaid)).filter(item => item.item_quantity > 0);

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper, drawer){
                    var svcs_seats = new SvcsScreenSeats({
                        $wrapper: $wrapper,
                        items_unpaid: that.seats_items_unpaid,
                        items_paid: that.seats_items_paid,
                        segments_passengers: that.segments_passengers,
                        passengers: that.passengers,
                        modals: that.modals,
                        locales: that.locales,
                        order_currency: that.order_currency,
                        analytics_dataset: that.analytics_dataset || null,

                        onButtonConfirmClick: function (data, component, event) {

                            var has_changes = false,
                                real_changes = [];

                            data.forEach(function (data_item) {
                                var item_quantity = data_item.hasOwnProperty('item_quantity')
                                    ? parseInt(data_item.item_quantity, 10)
                                    : 0;
                                if (item_quantity) {
                                    that.__saveSvcInCollection(that.seats_items_unpaid, data_item);
                                } else {
                                    that.__resetSvcInCollection(that.seats_items_unpaid, data_item);
                                }

                                that.__collectRealChanges(real_changes, data_item, seats_items_unpaid_initial);
                            });
                            that.__afterCollectionChanged(that.seats_items_unpaid, that.SVC_TYPES.seat);
                            that.__emitAnalyticsCartEvents(real_changes);
                            // Обновить "изначальный" набор, т.к. изменения корзины уже отправлены, но у посетителя есть шанс продолжить выбор
                            seats_items_unpaid_initial = JSON.parse(JSON.stringify(that.seats_items_unpaid)).filter(item => item.item_quantity > 0);

                            if (that.seats_incomplete_warning_enable) {
                                that.__initSvcsIncompleteWarning(that.SVC_TYPES.seat, drawer, svcs_seats);
                            } else {
                                drawer.close();
                            }
                        }
                    });
                },
            });
        });
    };

    PageSvcsAdd.prototype.__showSvcSegmentQtyTotal = function (collection) {
        var that = this;

        collection.forEach(function (item) {
            var item_id = item['item_id'].toString(),
                segment_id = item['segment_id'].toString(),
                item_price = parseFloat(item['item_price']),
                quantity,
                price;

            quantity = collection.reduce(function (qty, current) {
                if (
                    current['item_id'].toString() === item_id &&
                    current['segment_id'].toString() === segment_id
                ) {
                    return qty + parseInt(current['item_quantity'], 10);
                } else {
                    return qty;
                }
            }, 0);

            price = item_price * quantity;

            if (quantity > 0) {
                that.__showSvcItemTotal(
                    segment_id,
                    item_id,
                    quantity,
                    price,
                    item['currency']
                );
            } else {
                that.__hideSvcItemTotal(segment_id, item_id);
            }
        });
    };

    PageSvcsAdd.prototype.svcAddTotalDrawerInit = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svcs_add_total_drawer_call);

        $action.on('click', function (e){
            e.preventDefault();

            var content = that.$wrapper.find('.' + that.class.svcs_add_total_content).html(),
                title = $action.data('title');

            $.uiDrawer({
                position: 'bottom',
                header_title: title,
                content: content,
                custom_class: 'svcs-other',
                fluid: true,
                disable_content_scroll: true
            });
        });
    };

    PageSvcsAdd.prototype.svcLuggageDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_luggage_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_luggage_html}`).html();

            // Merge unpaid and default items (without overriding)
            var luggage_items_unpaid = that.__mergeIntoCollection(that.luggage_items_unpaid, that.luggage_items_default);
            // Save into unpaid
            that.luggage_items_unpaid = luggage_items_unpaid.slice();

            // deep clone with all embedded objects
            var items_unpaid_initial = JSON.parse(JSON.stringify(luggage_items_unpaid)).filter(item => item.item_quantity > 0);

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper, drawer){
                    new SvcsScreenLuggage ({
                        $wrapper: $wrapper,
                        items_unpaid: that.luggage_items_unpaid,
                        items_paid: that.luggage_items_paid,
                        modals: that.modals,
                        order_currency: that.order_currency,
                        screen_mode: 'drawer',
                        analytics_dataset: that.analytics_dataset || null,
                        onButtonConfirmClick: function (data, component, event) {
                            var real_changes = [];

                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.luggage_items_unpaid, data_item);
                                that.__collectRealChanges(real_changes, data_item, items_unpaid_initial);
                            });
                            that.__afterCollectionChanged(that.luggage_items_unpaid, that.SVC_TYPES.luggage);
                            that.__emitAnalyticsCartEvents(real_changes);
                            // Обновить "изначальный" набор, т.к. изменения корзины уже отправлены, но у посетителя есть шанс продолжить выбор
                            items_unpaid_initial = JSON.parse(JSON.stringify(that.luggage_items_unpaid)).filter(item => item.item_quantity > 0);

                            if (that.luggage_incomplete_warning_enable) {
                                that.__initSvcsIncompleteWarning(that.SVC_TYPES.luggage, drawer);
                            } else {
                                drawer.close();
                            }
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.luggage_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.luggage_items_unpaid, that.SVC_TYPES.luggage);

                            that.__emitAnalyticsCartEvents(items_unpaid_initial.map(item => {
                                item.item_quantity_diff = 0 - item.item_quantity;
                                return item;
                            }));
                            drawer.close();
                        }
                    })
                }
            });
        });
    };

    PageSvcsAdd.prototype.svcIfeMoviesDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_ife_movies_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_ife_movies_html}`).html();

            // Merge unpaid and default items (without overriding)
            var ife_movies_items_unpaid = that.__mergeIntoCollection(that.ife_movies_items_unpaid, that.ife_movies_items_default);
            // Save into unpaid
            that.ife_movies_items_unpaid = ife_movies_items_unpaid.slice();

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper, drawer){
                    new SvcsScreenOtherIfeMovies({
                        $wrapper: $wrapper,
                        items_unpaid: that.ife_movies_items_unpaid,
                        items_paid: that.ife_movies_items_paid,
                        order_currency: that.order_currency,
                        need_force_select: that.ife_movies_need_force_select,
                        onButtonConfirmClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.ife_movies_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.ife_movies_items_unpaid, that.SVC_TYPES.ife_movies);
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.ife_movies_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.ife_movies_items_unpaid, that.SVC_TYPES.ife_movies);
                        }
                    });
                }
            });
        });
    };

    PageSvcsAdd.prototype.svcMealDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_meal_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_meal_html}`).html();

            // Merge unpaid and default items (without overriding)
            var meal_items_unpaid = that.__mergeIntoCollection(that.meal_items_unpaid, that.meal_items_default);
            // Save into unpaid
            that.meal_items_unpaid = meal_items_unpaid.slice();

            // deep clone with all embedded objects
            var items_unpaid_initial = JSON.parse(JSON.stringify(meal_items_unpaid)).filter(item => item.item_quantity > 0);

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper, drawer){
                    new SvcsScreenOtherMeal({
                        $wrapper: $wrapper,
                        items_unpaid: that.meal_items_unpaid,
                        items_paid: that.meal_items_paid,
                        order_currency: that.order_currency,
                        analytics_dataset: that.analytics_dataset || null,
                        onButtonConfirmClick: function (data, component, event) {
                            var real_changes = [];

                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.meal_items_unpaid, data_item);
                                that.__collectRealChanges(real_changes, data_item, items_unpaid_initial);
                            });

                            that.__afterCollectionChanged(that.meal_items_unpaid, that.SVC_TYPES.meal);
                            that.__emitAnalyticsCartEvents(real_changes);
                            // Обновить "изначальный" набор, т.к. изменения корзины уже отправлены в GA, но у посетителя есть шанс продолжить выбор
                            items_unpaid_initial = JSON.parse(JSON.stringify(that.meal_items_unpaid)).filter(item => item.item_quantity > 0);

                            if (that.meal_incomplete_warning_enable) {
                                that.__initSvcsIncompleteWarning(that.SVC_TYPES.meal, drawer);
                            } else {
                                drawer.close();
                            }
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.meal_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.meal_items_unpaid, that.SVC_TYPES.meal);

                            that.__emitAnalyticsCartEvents(items_unpaid_initial.map(item => {
                                item.item_quantity_diff = 0 - item.item_quantity;
                                return item;
                            }));
                            drawer.close();
                        }
                    });
                }
            });
        });
    };

    PageSvcsAdd.prototype.svcInsuranceDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_insurance_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_insurance_html}`).html();

            // Merge unpaid and default items (without overriding)
            var insurance_items_unpaid = that.__mergeIntoCollection(that.insurance_items_unpaid, that.insurance_items_default);
            // Save into unpaid
            that.insurance_items_unpaid = insurance_items_unpaid.slice();

            // deep clone with all embedded objects
            var items_unpaid_initial = JSON.parse(JSON.stringify(insurance_items_unpaid)).filter(item => item.item_quantity > 0);

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper){
                    new SvcsScreenOtherInsurance({
                        $wrapper: $wrapper,
                        modals: that.modals,
                        items_unpaid: that.insurance_items_unpaid,
                        items_paid: that.insurance_items_paid,
                        order_currency: that.order_currency,
                        analytics_dataset: that.analytics_dataset || null,
                        onButtonConfirmClick: function (data, component, event) {
                            var real_changes = [];

                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.insurance_items_unpaid, data_item);
                                that.__collectRealChanges(real_changes, data_item, items_unpaid_initial);
                            });

                            that.__afterCollectionChanged(that.insurance_items_unpaid, that.SVC_TYPES.insurance);
                            that.__emitAnalyticsCartEvents(real_changes);
                            // Обновить "изначальный" набор, т.к. изменения корзины уже отправлены, но у посетителя есть шанс продолжить выбор
                            items_unpaid_initial = JSON.parse(JSON.stringify(that.insurance_items_unpaid)).filter(item => item.item_quantity > 0);
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.insurance_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.insurance_items_unpaid, that.SVC_TYPES.insurance);

                            that.__emitAnalyticsCartEvents(items_unpaid_initial.map(item => {
                                item.item_quantity_diff = 0 - item.item_quantity;
                                return item;
                            }));
                        }
                    });
                }
            });
        });
    };

    PageSvcsAdd.prototype.svcNoticeDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_notice_drawer_call}`);

        $action.on('click', function (e) {
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_notice_html}`).html();

            // Merge unpaid and default items (without overriding)
            var notice_items_unpaid = that.__mergeIntoCollection(that.notice_items_unpaid, that.notice_items_default);
            // Save into unpaid
            that.notice_items_unpaid = notice_items_unpaid.slice();

            // deep clone with all embedded objects
            var items_unpaid_initial = JSON.parse(JSON.stringify(notice_items_unpaid)).filter(item => item.item_quantity > 0);

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper) {
                    new SvcsScreenOtherNotice({
                        $wrapper: $wrapper,
                        items_unpaid: that.notice_items_unpaid,
                        items_paid: that.notice_items_paid,
                        order_currency: that.order_currency,
                        analytics_dataset: that.analytics_dataset || null,
                        onButtonConfirmClick: function (data, component, event) {
                            var real_changes = [];

                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.notice_items_unpaid, data_item);
                                that.__collectRealChanges(real_changes, data_item, items_unpaid_initial);
                            });

                            that.__afterCollectionChanged(that.notice_items_unpaid, that.SVC_TYPES.notice);
                            that.__emitAnalyticsCartEvents(real_changes);
                            // Обновить "изначальный" набор, т.к. изменения корзины уже отправлены, но у посетителя есть шанс продолжить выбор
                            items_unpaid_initial = JSON.parse(JSON.stringify(that.notice_items_unpaid)).filter(item => item.item_quantity > 0);
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.notice_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.notice_items_unpaid, that.SVC_TYPES.notice);

                            that.__emitAnalyticsCartEvents(items_unpaid_initial.map(item => {
                                item.item_quantity_diff = 0 - item.item_quantity;
                                return item;
                            }));
                        }
                    });
                }
            });
        });
    };

    /**
     * Генерирует события GA add_to_cart и remove_from_cart исходя из данных об изменениях услуг для
     * каждого купона (билета): для положительных — add, для отрицательных — remove
     *
     * @param {SegmentChangesItem[]} changes
     * @private
     */
    PageSvcsAdd.prototype.__emitAnalyticsCartEvents =function (changes) {
        var that = this,
            event_data;

        if (!changes.length) {
            return;
        }

        event_data = that.analytics_dataset.svcCartChange(changes);
        if (event_data.add_to_cart) {
            $.sa.analytics.gtag('event', 'add_to_cart', event_data.add_to_cart);
        }
        if (event_data.remove_from_cart) {
            $.sa.analytics.gtag('event', 'remove_from_cart', event_data.remove_from_cart);
        }
    }

    /**
     * Сбор изменений в наборе неоплаченных услуг при подтверждении выбора.
     * Сравнивается с изначальным набором
     *
     * @param changes_collection массив изменений
     * @param data_item услуга с указанием пассажиро-сегмента, которому назначена
     * @param initial_unpaid_items начальный набор неоплаченных услуг (собран при открытии раздела)
     * @private
     */
    PageSvcsAdd.prototype.__collectRealChanges = function (changes_collection, data_item, initial_unpaid_items) {
        var that = this,
            current_quantity = parseInt(data_item.item_quantity, 10) || 0,
            initial_item = initial_unpaid_items.find(svc => that.__isTheSameSvc(data_item, svc));

        if (initial_item) {
            var initial_quantity = parseInt(initial_item.item_quantity, 10) || 0;

            if (current_quantity !== initial_quantity) {
                changes_collection.push(Object.assign({}, data_item, {item_quantity_diff: current_quantity - initial_quantity}));
            }
        } else {
            changes_collection.push(Object.assign({}, data_item, {item_quantity_diff: current_quantity}));
        }

        return changes_collection;
    }

    PageSvcsAdd.prototype.__mergeIntoCollection = function (collection_target, collection_source) {
        if (
            !Array.isArray(collection_target) ||
            !Array.isArray(collection_source)
        ) {
            $.sa.error('Error merge collections: some of them is not an array.');
            return [];
        }
        if (!collection_target.length) {
            return collection_source;
        }
        if (!collection_source.length) {
            return collection_target;
        }

        var merged = collection_target.slice();
        collection_source.forEach(function (item_from_source) {
            var is_target_contains = collection_target.some(item_from_target => (
                item_from_source.segment_id.toString()   === item_from_target.segment_id.toString() &&
                item_from_source.passenger_id.toString() === item_from_target.passenger_id.toString() &&
                item_from_source.item_id.toString()      === item_from_target.item_id.toString()
            ));
            if (!is_target_contains) {
                merged.push(item_from_source);
            }
        });
        return merged;
    };

    PageSvcsAdd.prototype.__saveSvcInCollection = function (collection, svc_data) {
        var that = this,
            item_changed_index = collection.findIndex(selection => that.__isTheSameSvc(selection,svc_data)),
            quantity = svc_data.item_quantity ? parseInt(svc_data.item_quantity, 10) : 0,
            quantity_prev,
            quantity_diff;

        // if item found, update quantity
        if (item_changed_index !== -1) {
            quantity_prev = collection[item_changed_index]['item_quantity'];
            quantity_diff = quantity - quantity_prev;

            collection[item_changed_index]['item_quantity'] = quantity;
            collection[item_changed_index]['item_quantity_diff'] = quantity_diff;
        }
        // if item wasn't saved yet, save it now
        else {
            quantity_diff = quantity;
            collection.push(svc_data);
        }

        // update quantity_diff in the original data
        that.__afterSvcSelect(Object.assign({}, svc_data, {item_quantity_diff: quantity_diff}));
    };

    PageSvcsAdd.prototype.__resetSvcInCollection = function (collection, svc_data) {
        var that = this,
            item_changed_index = collection.findIndex(selection => that.__isTheSameSvc(selection, svc_data)),
            quantity_prev,
            quantity_diff;

        if (item_changed_index === -1) {
            return;
        }

        // if item found, update quantity
        quantity_prev = collection[item_changed_index]['item_quantity'];
        quantity_diff = -quantity_prev;

        collection[item_changed_index]['item_quantity'] = 0;
        collection[item_changed_index]['item_quantity_diff'] = quantity_diff;

        // update quantity_diff in the original data
        that.__afterSvcReset(Object.assign({}, svc_data, {item_quantity_diff: quantity_diff}));
    };

    // returns svc's index, if found, otherwise returns false
    PageSvcsAdd.prototype.__hasSvcInCollection = function (collection, data) {
        var that = this;

        if (!collection || !collection.length) {
            return false;
        }

        return collection.some(svc => that.__isTheSameSvc(svc, data));
    };

    PageSvcsAdd.prototype.__isTheSameSvc = function (svc, data) {
        return (
            svc.segment_id.toString()   === data.segment_id.toString() &&
            svc.passenger_id.toString() === data.passenger_id.toString() &&
            svc.item_id.toString()      === data.item_id.toString() &&
            ((svc.item_text             === data.item_text) || !data.item_text)
        );
    };

    PageSvcsAdd.prototype.__afterCollectionChanged = function (collection, collection_svcs_type) {
        var that = this;
        that.__showSvcSegmentQtyTotal(collection);
        that.__svcBadgeAddedSet(collection_svcs_type, collection);
        that.__svcSetActionState(collection_svcs_type, collection);
    };

    PageSvcsAdd.prototype.__afterSvcSelect = function (svc_data) {
        var that = this,
            svc_quantity_diff = svc_data.item_quantity_diff ? parseInt(svc_data.item_quantity_diff, 10) : 0,
            svc_price = svc_data.item_price ? parseFloat(svc_data.item_price) : 0;

        if (0 !== svc_quantity_diff) {
            that.__changeTotal(svc_price, svc_quantity_diff);
            that.__displayTotal();

            that.onSvcSelected(svc_data, that);
        }
    };

    PageSvcsAdd.prototype.__afterSvcReset = function (svc_data) {
        var that = this,
            svc_quantity_diff = svc_data.item_quantity_diff ? parseInt(svc_data.item_quantity_diff, 10) : 0,
            svc_price = svc_data.item_price ? parseFloat(svc_data.item_price) : 0;

        if (0 !== svc_quantity_diff) {
            that.__changeTotal(svc_price, svc_quantity_diff);
            that.__displayTotal();

            that.onSvcReset(svc_data, that);
        }
    };

    /**
     * Toggle (show or hide) badge 'Added' for specified svc, depending on specified state
     * @param {String} type Type of badge. Values: 'added', 'paid'
     * @param {Boolean} state Show or hide badge
     * @param {String|null} svc_type If not specified - toggle badges for all svcs on page
     * @private
     */
    PageSvcsAdd.prototype.__svcBadgeToggle = function (type, state, svc_type = null) {
        var that = this,
            $svc = svc_type
                ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type=' + svc_type + ']')
                : that.$wrapper.find('.' + that.class.svc_card_wrapper),
            badge_class = that.class['svc_badge_' + type],
            $svc_badge = $svc.find('.' + badge_class);
        $svc_badge.toggle(state);
    };

    PageSvcsAdd.prototype.__svcBadgeSetQuantity = function (type, svc_type, quantity = 0) {
        var that = this,
            $svc = svc_type
                ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type=' + svc_type + ']')
                : that.$wrapper.find('.' + that.class.svc_card_wrapper),
            badge_class = that.class['svc_badge_' + type],
            badge_quantity_class = that.class['svc_badge_' + type + '_quantity'],
            $svc_badge = $svc.find('.' + badge_class),
            $svc_badge_quantity = $svc_badge.find('.' + badge_quantity_class);

        if (!quantity) {
            $svc_badge_quantity.hide();
        } else {
            $svc_badge_quantity.text('x' + quantity).show();
        }
    };

    PageSvcsAdd.prototype.__svcBadgeAddedSet = function (svc_type, items_list) {
        var that = this,
            quantity_all = that.__countItemsQuantity(items_list);

        that.__svcBadgeSetQuantity('added', svc_type, quantity_all);
        that.__svcBadgeToggle('added', !!quantity_all, svc_type);
    };

    PageSvcsAdd.prototype.__svcBadgePaidSet = function (svc_type, items_list) {
        var that = this,
            quantity_all = that.__countItemsQuantity(items_list);

        that.__svcBadgeSetQuantity('paid', svc_type, quantity_all);
        that.__svcBadgeToggle('paid', !!quantity_all, svc_type);
    };

    PageSvcsAdd.prototype.__svcSetActionState = function (svc_type, items_list) {
        var that = this,
            quantity_all = that.__countItemsQuantity(items_list);

        if (quantity_all > 0) {
            that.__svcSetActionStateEdit(svc_type);
        } else {
            that.__svcSetActionStateAdd(svc_type);
        }
    };

    PageSvcsAdd.prototype.__countItemsQuantity = function (items) {
        var quantity = 0;
        items.forEach(function (selection) {
            var item_quantity = selection.hasOwnProperty('item_quantity')
                ? parseInt(selection.item_quantity, 10)
                : 0;
            quantity += item_quantity;
        });
        return quantity;
    };

    PageSvcsAdd.prototype.__getQuantityAll = function (collection) {
        var that = this;
        return that.__countItemsQuantity(collection);
    };

    PageSvcsAdd.prototype.__svcSetActionStateAdd = function (svc_type = null) {
        var that = this,
            $svc = svc_type
                ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type="' + svc_type + '"] .' + that.class.svc_type_card)
                : that.$wrapper.find('.' + that.class.svc_card_wrapper + ' .' + that.class.svc_type_card),
            $svc_action_edit = $svc.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc.find('.' + that.class.svc_action_add);

        $svc_action_edit.hide();
        $svc_action_add.show();
    };

    PageSvcsAdd.prototype.__svcSetActionStateEdit = function (svc_type) {
        var that = this,
            $svc = that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type="' + svc_type + '"] .' + that.class.svc_type_card),
            $svc_action_edit = $svc.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc.find('.' + that.class.svc_action_add);

        $svc_action_add.hide();
        $svc_action_edit.show();
    };

    PageSvcsAdd.prototype.__showSvcItemTotal = function (segment_id, item_id, quantity, segment_price, currency) {
        var that = this;

        if (!quantity) {
            that.__hideSvcItemTotal(segment_id, item_id);
            return;
        }

        if (!segment_id || (Array.isArray(segment_id) && !segment_id.length) || !item_id || !currency) {
            return;
        }

        var $total_segment = that.$wrapper.find('.' + that.class.svcs_add_total_segment + '[data-segment-id=' + segment_id + ']'),
            $total_item = $total_segment.find('.' + that.class.svcs_add_total_item + '[data-id=' + item_id + ']'),
            $total_item_count = $total_item.find('.' + that.class.svcs_add_total_item_count),
            $total_item_amount = $total_item.find('.' + that.class.svcs_add_total_item_amount),
            segment_price_formatted = $.sa.format.price(parseFloat(segment_price), currency);

        $total_item_count.text('x' + parseInt(quantity, 10));
        $total_item_amount.text(segment_price_formatted);
        $total_item.show();
    }

    PageSvcsAdd.prototype.__hideSvcItemTotal = function (segment_id, item_id) {
        if (!segment_id || !item_id) {
            return;
        }

        var that = this,
            $total_segment = that.$wrapper.find('.' + that.class.svcs_add_total_segment + '[data-segment-id=' + segment_id + ']'),
            $total_item = $total_segment.find('.' + that.class.svcs_add_total_item + '[data-id=' + item_id + ']');

        $total_item.hide();
    };

    PageSvcsAdd.prototype.__changeTotal = function (value, multiplier = 1) {
        value = parseFloat(value);
        multiplier = parseFloat(multiplier);

        var that = this,
            amount = value * multiplier;

        if (amount < 0 && that.total < Math.abs(amount)) {
            $.sa.log('Error count total price');
        } else {
            that.total += amount;
        }
    };

    PageSvcsAdd.prototype.__displayTotal = function () {
        var that = this;

        if (!that.order_currency) {
            return;
        }

        var $total_amount = that.$wrapper.find('.' + that.class.svcs_add_total_amount),
            total_amount_text = $.sa.format.price(that.total, that.order_currency);

        $total_amount.text(total_amount_text);
    };

    PageSvcsAdd.prototype.__initSvcsIncompleteWarning = function (type, drawer, seats = null) {
        var that = this;

        if (type === that.SVC_TYPES.seat && seats) {
            if (that.__isSvcIncomplete(that.SVC_TYPES.seat, seats)) {
                that.__renderWarningModal(type, drawer);
            } else {
                drawer.close();
            }
        }

        if (type === that.SVC_TYPES.luggage) {
            if (that.__isSvcIncomplete(that.SVC_TYPES.luggage)) {
                that.__renderWarningModal(type, drawer);
            } else {
                drawer.close();
            }
        }

        if (type === that.SVC_TYPES.meal) {
            if (that.__isSvcIncomplete(that.SVC_TYPES.meal)) {
                that.__renderWarningModal(type, drawer);
            } else {
                drawer.close();
            }
        }
    };

    PageSvcsAdd.prototype.__getSelectedSvcs = function (type) {
        var that = this,
            svcs_selected,
            svcs_selected_paid,
            svcs_selected_clear;

        if (type === that.SVC_TYPES.seat) {
            svcs_selected = that.seats_items_unpaid;
            svcs_selected_paid = that.seats_items_paid;
        }

        if (type === that.SVC_TYPES.luggage) {
            svcs_selected = that.luggage_items_unpaid;
            svcs_selected_paid = that.luggage_items_paid;
        }

        if (type === that.SVC_TYPES.meal) {
            svcs_selected = that.meal_items_unpaid;
            svcs_selected_paid = that.meal_items_paid;
        }

        if (svcs_selected_paid.length) {
            svcs_selected = svcs_selected_paid.concat(svcs_selected);
        }

        svcs_selected_clear = PageSvcs.prototype.svcsSelectedCleanSort(svcs_selected);

        return svcs_selected_clear;
    };

    PageSvcsAdd.prototype.__isSvcIncomplete = function (type, seats = null) {
        var that = this,
            svcs_selected_clear = that.__getSelectedSvcs(type);

        if (!svcs_selected_clear.length) {
            return false;
        }

        for(var order_passenger_id of that.order_passengers_ids) {
            var passenger_id = parseInt(order_passenger_id, 10),
                passenger_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                    return parseInt(svc_selected.passenger_id, 10) === passenger_id;
                });

            if (passenger_matched === -1) {
                continue;
            }

            // If there is a match by passenger_id in the svcs_selected_clear array,
            // then check is there a match in each segment
            for (var order_segment_id of that.order_segments_ids) {
                var segment_id = parseInt(order_segment_id, 10),
                    segment_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                        return  parseInt(svc_selected.passenger_id, 10) === passenger_id &&
                                parseInt(svc_selected.segment_id, 10) === segment_id;
                    });

                // if segment matched remove object with this segment from array for next loop check
                if (segment_matched !== -1) {
                    svcs_selected_clear.splice(segment_matched, 1);
                }

                if (segment_matched === -1) {
                    if (type === that.SVC_TYPES.seat) {
                        return SvcsScreenSeats.prototype.isChairAvailable(seats, segment_id);
                    } else {
                        return true;
                    }
                }
            }
        }

        return false;
    };

    PageSvcsAdd.prototype.__renderWarningModal = function (type, drawer) {
        var that = this,
            html = null;

        if (type === that.SVC_TYPES.seat) {
            html = that.seats_incomplete_warning_html;
        }
        if (type === that.SVC_TYPES.luggage) {
            html = that.luggage_incomplete_warning_html;
        }
        if (type === that.SVC_TYPES.meal) {
            html = that.meal_incomplete_warning_html;
        }

        $.uiModal({
            html: html,
            onButtonCancelClick: function () {
                drawer.close();
            }
        });
    };

    return PageSvcsAdd;
})($);